import React from 'react';

interface RatingProps {
  score: number;
  onRate: (score: number) => void;
}

const Rating: React.FC<RatingProps> = ({ score, onRate }) => {
  const scores = [1, 2, 3, 4, 5];

  return (
    <div>
      {scores.map((s) => (
        <button
          key={s}
          onClick={() => onRate(s)}
          className={`btn ${score === s ? 'btn-primary' : 'btn-outline-primary'} me-1`}
        >
          {s}
        </button>
      ))}
    </div>
  );
};

export default Rating;
